import { GridApi, GridReadyEvent, IRowNode, IToolPanelParams } from "@ag-grid-community/core";
import { FormControl } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { GridOptions } from "@ag-grid-community/core";
import { Component, OnDestroy } from "@angular/core";
import { CurrencyPipe } from "@angular/common";
import { MatSnackBar } from "@angular/material/snack-bar";
import { filter, takeUntil } from "rxjs/operators";
import { PurchasingService } from "src/app/modules/planyard/purchasing.service";
import { AddProductToSeasons, Breakdown, SaveProductEvent } from "src/app/models/purchasing.model";
import { SmartGridBaseConfigService } from "src/app/data-grid/smart-grid-base-config.service";
import { Subject } from "rxjs";
import { AddEventDialogComponent } from "../presentational/add-event-dialog/add-event-dialog.component";
import { SeasonsDialogComponent } from './../presentational/seasons-dialog/seasons-dialog.component';
import { SnackbarComponent } from "src/app/components/snackbar/snackbar.component";
import { ShipyardService } from "../../shipyard/shipyard.service";

@Component({
  selector: "app-product-breakdown-panel",
  templateUrl: "./product-breakdown-panel.component.html",
  styleUrls: ["./product-breakdown-panel.component.scss", "../panel.scss"],
})
export class ProductBreakdownPanelComponent implements OnDestroy {
  params: IToolPanelParams;
  product: any;
  breakdown: Breakdown;
  demandSkus: any[];
  fbaStockSkus: any[];
  demandTotal: number;
  additionalDemandTotal: number;
  stockTotal: number;
  private _suggestionTotal: number;
  appliedSeasonalVelocity: number;
  get suggestionTotal() {
    return this._suggestionTotal;
  };

  set suggestionTotal(value: number) {
    this._suggestionTotal = value;
    this.setGridColumn("Restock", "Restock", value)
  }
  suggestionSelection: FormControl = new FormControl("");
  selectedNode: IRowNode;
  private destroy$ = new Subject<void>();
  inboundPoGridApi: GridApi;
  draftPoGridApi: GridApi;
  skuDemandGridApi: GridApi;
  deductDueToFbaGridApi: GridApi;
  gridOptions: GridOptions = {
    ...this.smartGridBaseConfigService.gridOptions,
    onGridSizeChanged: (e) => this.resized(e),
  };
  isSeasonalApplied:boolean=false;
  poColumnDef = [
    {
      field: "poNumber",
      headerName: "ID",
      width: 75,
    },
    {
      field: "vendorName",
      headerName: "Vendor",
      width: 75,
    },
    {
      field: "qty",
      width: 75,
      valueGetter: (params) => {
        return (Number(params.data.qty) || 0).toLocaleString('en');
      },
    },
    {
      field: "price",
      width: 75,
      valueFormatter: (params) => this.currencyPipe.transform(params.value),
    },
    {
      field: "status",
      width: 90,
    },
  ];
  dedeuctFbaColumnDef = [
    {
      field: "Sku",
      headerName: "SKU's",
      cellRenderer: "skuCellRendererComponent",
    },
    {
      field: "TotalFbaStock",
      headerName: "FBA Stock",
      width: 90,
      valueGetter: (params) => {
        return (Number(params.data.TotalFbaStock) || 0).toLocaleString('en');
      },
    },
    {
      field: "SkuAdjustment",
      headerName: "SKU Adjustment",
      width: 100,
      valueGetter: (params) => {
        return (Number(params.data.SkuAdjustment) || 0).toLocaleString('en');
      },
    },
  ];

  skuDemandColumnDef = [
    {
      field: "Sku",
      headerName: "SKU's",
      width: 250,
      cellRenderer: "skuCellRendererComponent",
    },
    {
      field: "Suggested",
      cellRenderer: "sgSkuQtyCellRendererComponent",
      width: 140,
      cellRendererParams: {
        callbackFunction: this.skuDemandTotal.bind(this),
        isShowSuggestionOnly:true
      },
    },
  ];

  draftPoGridOptions: GridOptions = {
    ...this.gridOptions,
    columnDefs: this.poColumnDef,
    onGridReady: (e: GridReadyEvent) => {
      this.draftPoGridApi = e.api;
      this.draftPoGridApi.setGridOption('rowData', this.breakdown.draftPos);
      this.draftPoGridApi.sizeColumnsToFit();
    },
  };
  inboundPoGridOptions: GridOptions = {
    ...this.gridOptions,
    columnDefs: this.poColumnDef,
    onGridReady: (e: GridReadyEvent) => {
      this.inboundPoGridApi = e.api;
      this.inboundPoGridApi.setGridOption('rowData', this.breakdown.inboundPos);
      this.inboundPoGridApi.sizeColumnsToFit();
    },
  };

  deductDueToFbaGridOptions: GridOptions = {
    ...this.gridOptions,
    columnDefs: this.dedeuctFbaColumnDef,
    rowHeight: 56,
    onGridReady: (e: GridReadyEvent) => {
      this.deductDueToFbaGridApi = e.api;
      this.deductDueToFbaGridApi.setGridOption('rowData', this.breakdown.fbaStockSkus);
      this.deductDueToFbaGridApi.sizeColumnsToFit();
    },
  };

  skuDemandGridOptions: GridOptions = {
    ...this.gridOptions,
    columnDefs: this.skuDemandColumnDef,
    headerHeight: 0,
    rowHeight: 56,
    onGridReady: (e: GridReadyEvent) => {
      this.skuDemandGridApi = e.api;
      this.skuDemandGridApi.setGridOption('rowData', this.breakdown.demandSkus);
      this.skuDemandGridApi.sizeColumnsToFit();
    },
  };

  constructor(
    private purchasingService: PurchasingService,
    private dialog: MatDialog,
    private smartGridBaseConfigService: SmartGridBaseConfigService,
    private currencyPipe: CurrencyPipe,
    private snackBar: MatSnackBar,
    public shipyardService: ShipyardService
  ) {
    this.shipyardService.seasonalValueChanged.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
      if(res){
        if(res.amount && !res.isUpdateSuggested){
          this.isSeasonalApplied=true
          this.suggestionTotal=res.amount;
          this.appliedSeasonalVelocity = res.appliedSeasonalVelocity;
          this.additionalDemandTotal = this.additionalDemandTotal + (this.appliedSeasonalVelocity)
        }
        else{
          this.isSeasonalApplied=false;
          this.additionalDemandTotal = this.additionalDemandTotal - (this.appliedSeasonalVelocity);
        }
      }
    })
  }

  agInit(params: IToolPanelParams): void {
    this.params = params;

    this.suggestionSelection.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((e) => this.setGridColumn("Restock","SuggestedQty",e));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  setGridColumn(column: string, key: string, value) {
    if(!this.isSeasonalApplied){
    this.product[key] = value;
    this.selectedNode?.setDataValue(
      column,
      key !== column ? this.selectedNode.data[column].toString() : value
    );
    }
  }

  calculateTotals(): void {
    if(!this.isSeasonalApplied){
    this.demandTotal = this.calculateSkuDemandTotal();
    this.additionalDemandTotal = this.additionalItemsTotalFn();
    this.stockTotal = this.stockTotalFn();
    this.suggestionTotal = (this.demandTotal + this.additionalDemandTotal) - this.stockTotal;
    }
  }

  additionalItemsTotalFn(): number {
    return (
      this.breakdown.eventsTotal +
      this.breakdown.demandBufferTotal +
      this.breakdown.seasonsTotal
    );
  }

  stockTotalFn(): number {
    return this.breakdown.skuFbaTotal + (this.breakdown.warehouseStock - this.breakdown.demandBuffers[0].amount) + this.breakdown.draftPoTotal + this.breakdown.inboundPoTotal;
  }

  loadBreakdownInfo() {
    this.breakdown = undefined;
    this.purchasingService
      .GetSuggestionBreakDown(this.product.ItemId).pipe(takeUntil(this.destroy$))
      .subscribe((e: Breakdown) => {
        this.breakdown = e;
        if(this.breakdown){
          if(this.selectedNode)  this.selectedNode.data.breakdown = this.breakdown;
          this.breakdown.demandBufferTotal = this.breakdown.demandBuffers[1].amount
          this.setupPanel();
        }       
      });
  }

  setupPanel() {
    this.calculateTotals();
    this.resetAllGrids();
  }

  resetAllGrids() {
    if (this.draftPoGridApi) {
      this.draftPoGridApi.setGridOption('rowData', this.breakdown.draftPos);
    }
    if (this.inboundPoGridApi) {
      this.inboundPoGridApi.setGridOption('rowData', this.breakdown.inboundPos);
    }
    if (this.skuDemandGridApi) {
      this.skuDemandGridApi.setGridOption('rowData', this.breakdown.demandSkus);
    }
    if (this.deductDueToFbaGridApi) {
      this.deductDueToFbaGridApi.setGridOption('rowData', this.breakdown.fbaStockSkus);
    }
  }

  addEvent(event?: SaveProductEvent) {
    this.dialog
      .open(AddEventDialogComponent, {
        width: "500px",
        data: {
          productId: this.product.ItemId,
          event: event,
        },
      })
      .afterClosed()
      .pipe(filter((e) => e))
      .subscribe((e: SaveProductEvent) => {
        this.loadBreakdownInfo();
      });
  }

  deleteEvent(productEventId) {
    this.purchasingService.DeleteProductEvent(productEventId).pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.loadBreakdownInfo();
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: 'Event deleted',
            action: 'Dismiss',
            type: 'success',
          },
        }
    );
    });
  }

  addSeason() {
    this.dialog
      .open(SeasonsDialogComponent, {
        width: "500px",
        data: {
          seasons: this.breakdown.seasons || [],
        }
      })
      .afterClosed()
      .pipe(filter((e) => e))
      .subscribe((e: any[]) => {
        const seasonIds: number[] = e.map(e => e.seasonId);
        const payload: AddProductToSeasons = {
          productId: this.product.ItemId,
          seasonIds: seasonIds,
        };
        this.purchasingService.AddProductToSeasons(payload).pipe(takeUntil(this.destroy$)).subscribe((response: any) => {
          this.loadBreakdownInfo();
        });
      });
  }

  removeSeason(seasonId) {
    const seasons = this.breakdown.seasons.filter(e => e.seasonId !== seasonId);
    const payload: AddProductToSeasons = {
      productId: this.product.ItemId,
      seasonIds: seasons.map(e => e.seasonId),
    }
      
    this.purchasingService.AddProductToSeasons(payload).pipe(takeUntil(this.destroy$)).subscribe((response: any) => {
      this.loadBreakdownInfo();
    });
  }

  selectSuggestionValue() {
    this.suggestionSelection.setValue(this.suggestionTotal);
  }

  refresh(): void {
    const selectedRow = this.params.api.getSelectedRows();
    if(selectedRow.length){
      if (selectedRow[0]) {
        this.product = selectedRow[0];
        this.selectedNode = this.params.api.getRowNode(this.product.ItemId.toString());
        
        if (this.selectedNode.data.breakdown) {
          this.breakdown = this.selectedNode.data.breakdown;
          this.setupPanel();
        } else {
          this.loadBreakdownInfo();
        }
        this.suggestionSelection.setValue(
          this.product.SelectedQty ? this.product.SelectedQty : 0,
          { emitEvent: false }
        );
      }
    }else{
      const selectedRow = this.purchasingService.selectedSidePanelSku
      if(selectedRow){
        this.product = selectedRow;
        
        if (this.product.breakdown) {
          this.breakdown = this.product.breakdown;
          this.setupPanel();
        } else {
          this.loadBreakdownInfo();
        }
        this.suggestionSelection.setValue(
          this.product.SelectedQty ? this.product.SelectedQty : 0,
          { emitEvent: false }
        );
      }
    }
   
    
    if (this.product) {
      this.suggestionSelection.setValue(
        this.product.SelectedQty ? this.product.SelectedQty : 0,
        { emitEvent: false }
      );
    }
  }

  totalChanged(key: string, number: number) {
    this.breakdown[key] = +number;
  }

  totalChangedWithRecalculate(key: string, number: number) {
    this.totalChanged(key, number);
    this.calculateTotals();
  }

  skuDemandTotal() {
    const total = this.calculateSkuDemandTotal();
    this.totalChanged('skuDemandTotal', total);
    this.calculateTotals();
  }

  calculateSkuDemandTotal() {
    return this.breakdown.demandSkus.reduce((a, b) => {
      const amount = b['SelectedQty'] || b['Suggested'];
      return a + (amount * b['Qty']);
    }, 0);
  }

  resized(e) {
    e.api.sizeColumnsToFit();
  }
}
